import { getWordpressPostList } from "@src/functions/wordpress";
import WordpressPostList from "../common/components/WordpressPostList";

export async function getServerSideProps() {
  const postJson = await getWordpressPostList("1385");
  return {
    props: { data: postJson },
  }
}

function Materials ({ data }: any) {
  return (
    <WordpressPostList
      group="materials"
      titleName="Waste Streams"
      listTitle="Waste Streams"
      data={data}
    />
  );
};

export default Materials;